// Generated by scripts/build-ui-icons.mjs.
export { LockSimple as default } from "../ui/glyphs-5";
